import { formElementHelper, formHelper, FormSchema } from '@jht/react-library';
import { VirtualizedAutocomplete } from '../../components/Autocomplete/Autocomplete';
import { Country, State } from '../../models';
import { ExistingFacilityName } from './ExistingFacilityName';

export const newFacilityFormSchema = (
  values: any,
  countries: Country[],
  states: State[],
  existingFacilities: string[],
): FormSchema => {
  return formHelper(
    [
      formElementHelper({
        fullWidth: true,
        name: 'name',
        label: 'Name',
        value: values.name,
        inputType: 'custom',
        existingfacilities: existingFacilities,
        component: ExistingFacilityName,
        type: 'text',
        required: true,
        validation: {
          required: true,
          function: (value: string) => {
            return !existingFacilities.some(
              name => name.trim().toLowerCase() === value.trim().toLowerCase(),
            );
          },
        },
        validationMessages: {
          required: 'Name is required',
          function: 'Facility name already exists',
        },
      }),
      formElementHelper({
        fullWidth: true,
        name: 'street1',
        label: 'Street',
        value: values.street1,
        inputType: 'input',
        type: 'text',
        required: true,
        validation: { required: true },
        validationMessages: {
          required: 'Street address is required',
        },
      }),
      formElementHelper({
        fullWidth: true,
        name: 'street2',
        label: 'Street (Optional)',
        value: values.street2,
        inputType: 'input',
        type: 'text',
      }),
      formElementHelper({
        fullWidth: true,
        name: 'city',
        label: 'City',
        value: values.city,
        inputType: 'input',
        type: 'text',
        required: true,
        validation: { required: true },
        validationMessages: {
          required: 'City is required',
        },
      }),
      formElementHelper({
        fullWidth: true,
        name: 'country',
        label: 'Country',
        value: values.countryId || '',
        inputType: 'select',
        type: 'text',
        options: countries.map(c => {
          return { value: c.id.toString(), label: c.printableName };
        }),
        required: true,
        validation: { required: true },
        validationMessages: {
          required: 'Country is required',
        },
      }),
      !!states.length &&
        formElementHelper({
          fullWidth: true,
          name: 'state',
          label: 'State',
          value: values.stateId || '',
          inputType: 'select',
          type: 'text',
          options: states.map(s => {
            return { value: s.id.toString(), label: s.printableName };
          }),
          required: !!states.length,
          validation: { required: !!states.length },
          validationMessages: {
            required: 'State is required',
          },
        }),
      formElementHelper({
        fullWidth: true,
        name: 'postalCode',
        label: 'Postal Code',
        value: values.postalCode,
        inputType: 'input',
        type: 'text',
        required: true,
        validation: { required: true },
        validationMessages: {
          required: 'Postal code is required',
        },
      }),
    ].filter(el => !!el),
  );
};

export const existingFacilityFormSchema = (
  values: { name: string; id?: string },
  facilities: any,
): FormSchema => {
  return formHelper([
    formElementHelper({
      fullWidth: true,
      name: 'facility',
      label: 'Facility',
      value: values.id,
      options: (facilities || []).map(f => {
        return { value: f.id.toString(), label: f.name };
      }),
      type: 'text',
      required: true,
      validation: { required: true },
      validationMessages: {
        required: 'Please select a facility.',
      },
      component: VirtualizedAutocomplete,
    }),
  ]);
};
